import React from 'react';
import './BaseCard.scss';

function BaseCard({ title,subtitle, children, className = '' }) {
  return (
    <div className={`base-card ${className}`}>
      <div className="base-card__header">
        <h3 className="base-card__title">{title}</h3>
        <p className="base-card__subtitle">{subtitle}</p>
      </div>
      <div className="base-card__content">
        {children}
      </div>
    </div>
  );
}

export default React.memo(BaseCard); 